import { ReportPage } from 'types/reporting/reportPage';
import {
    InvoicedFeesByCaseAndAssignmentRow,
    InvoicedFeesByCaseAndAssignmentTotals,
    WipByCaseAndTimecardStatusRow,
    WipByCaseAndTimecardStatusTotals,
    WipByCaseRow,
    WipByCaseTotals,
} from 'types/reporting/operations';
import { portalAPI } from './portalAPI';
import { reportQuery } from './util/reportQuery';

const reportingOperationsApi = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        getWipByCaseReport: reportQuery<ReportPage<WipByCaseRow, WipByCaseTotals>>(
            builder,
            '/v1/reporting/wip-by-case'
        ),
        getWipByCaseAndTimecardStatusReport: reportQuery<
            ReportPage<WipByCaseAndTimecardStatusRow, WipByCaseAndTimecardStatusTotals>
        >(builder, '/v1/reporting/wip-by-case-and-timecard-status'),
        getInvoicedFeesByCaseAndAssignmentReport: reportQuery<
            ReportPage<InvoicedFeesByCaseAndAssignmentRow, InvoicedFeesByCaseAndAssignmentTotals>
        >(builder, '/v1/reporting/invoiced-fees-by-case-and-assignment'),
    }),
});

export const {
    useLazyGetWipByCaseReportQuery,
    useLazyGetWipByCaseAndTimecardStatusReportQuery,
    useLazyGetInvoicedFeesByCaseAndAssignmentReportQuery,
} = reportingOperationsApi;
